import { BehaviorSubject } from 'rxjs';

const STORAGEKEY_EDGE_THICKNESS = 'G:edge_thickness';
const STORAGEKEY_EDGE_COLOR = 'G:edge_color';
const STORAGEKEY_NODE_DRAGGABLE = 'G:node_draggable';

export class Config {
  private static instance: Config;

  public static getInstance(): Config {
    if (!Config.instance) {
      Config.instance = new Config();
    }
    return Config.instance;
  }

  edge_thickness: BehaviorSubject<number>;
  edge_color: BehaviorSubject<string>;
  node_draggable: BehaviorSubject<boolean>;
  pan_draggable: BehaviorSubject<boolean>;

  private constructor() {
    this.edge_thickness = new BehaviorSubject(2);
    this.edge_color = new BehaviorSubject('gradient');
    this.node_draggable = new BehaviorSubject(true);
    this.pan_draggable = new BehaviorSubject(false);
    this.loadConfig();
    this.edge_thickness.subscribe((val) => {
      localStorage.setItem(STORAGEKEY_EDGE_THICKNESS, val.toString());
    });
    this.edge_color.subscribe((val) => {
      localStorage.setItem(STORAGEKEY_EDGE_COLOR, val);
    });
    // this.node_draggable.subscribe((val) => {
    //   localStorage.setItem(STORAGEKEY_NODE_DRAGGABLE, val.toString());
    // });
  }

  private loadConfig() {
    this.edge_thickness.next(
      this.loadValue(this.edge_thickness, STORAGEKEY_EDGE_THICKNESS) as number,
    );
    this.edge_color.next(this.loadValue(this.edge_color, STORAGEKEY_EDGE_COLOR) as string);
    // this.node_draggable.next(
    //   this.loadValue(this.node_draggable, STORAGEKEY_NODE_DRAGGABLE) as boolean,
    // );
  }

  private loadValue<T>(subject: BehaviorSubject<T>, key: string) {
    const val = localStorage.getItem(key);
    if (val) {
      if (typeof subject.value === 'number') {
        return Number(val);
      } else {
        return val;
      }
    } else {
      return subject.value;
    }
  }
}
